"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/react-wrapper.js"
/*!****************************************!*\
  !*** ./js/components/react-wrapper.js ***!
  \****************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_dom_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! react-dom/client */ "./node_modules/react-dom/client.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! json-6 */ "./node_modules/json-6/dist/index.js");
/* harmony import */ var json_6__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(json_6__WEBPACK_IMPORTED_MODULE_3__);

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((Component, container, propsEl) => {
  console.log("react wrapper");
  //component is a pre-compiled class
  //container is where you want to inject component
  //propEl pass prop when injecting
  var appContainer = document.querySelectorAll(container);
  var singlePropsEl = document.querySelector(propsEl);
  var props = {};
  if (singlePropsEl) {
    console.log(singlePropsEl === null || singlePropsEl === void 0 ? void 0 : singlePropsEl.innerHTML);
    props = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse(singlePropsEl === null || singlePropsEl === void 0 ? void 0 : singlePropsEl.innerHTML) || {};
  }
  return [...appContainer].map(appTarget => {
    var initialized = appTarget.dataset.initialized || false;
    if (appTarget && !initialized) {
      if (!singlePropsEl) {
        if (propsEl) {
          var _appTarget$querySelec;
          props = {};
          props = json_6__WEBPACK_IMPORTED_MODULE_3___default().parse((_appTarget$querySelec = appTarget.querySelector(propsEl)) === null || _appTarget$querySelec === void 0 ? void 0 : _appTarget$querySelec.innerHTML) || {}; //get json from the script id 
        }
      }
      // console.log(props);
      appTarget.dataset.initialized = true;
      var root = (0,react_dom_client__WEBPACK_IMPORTED_MODULE_2__.createRoot)(appTarget);

      // Store the root reference for potential re-renders
      appTarget._reactRoot = root;

      // Initial render
      root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Component, {
        shopifyData: props
      }));

      // Listen for cart form updates
      appTarget.addEventListener('cartFormUpdate', event => {
        var newProps = _objectSpread(_objectSpread({}, props), event.detail);
        root.render(/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(Component, {
          shopifyData: newProps
        }));
      });
      return root;
    }
  });
});

/***/ },

/***/ "./js/components/react/ResponsiveImage.js"
/*!************************************************!*\
  !*** ./js/components/react/ResponsiveImage.js ***!
  \************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_ref => {
  var {
    aspectratio = 1,
    image,
    settings
  } = _ref;
  var min = 100;
  var max = 10000;
  var diff = max - min;
  var generated_image_id = Date.now() / diff + min;
  var displayImage = image;
  if (!displayImage) {
    displayImage = {
      width: 1920,
      height: 1080,
      id: Date.now(),
      src: 'https://cdn.shopify.com/s/files/1/0422/2255/1191/files/placeholderImage.webp?v=1692958737'
    };
  }
  if (typeof displayImage == 'string') {
    displayImage = {
      src: displayImage,
      width: 1920,
      height: 1080,
      id: generated_image_id
    };
  }
  var {
    imageFit
  } = settings || {};
  var {
    height: maxHeightImage,
    id: image_id,
    src: imageSrc,
    width: maxWidthImage
  } = displayImage;
  var IMAGE_WIDTHS = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2160, 2376, 2592, 2808, 3024];
  var getImageWidths = nativeWidth => {
    var imageWidths = [];
    for (var i = 0; i < IMAGE_WIDTHS.length; i++) {
      var width = IMAGE_WIDTHS[i];
      if (nativeWidth > width) {
        imageWidths.push(width);
      } else {
        imageWidths.push(nativeWidth);
        break;
      }
    }
    return imageWidths.join(',');
  };
  var imageSizes = getImageWidths(displayImage.width).split(',');
  var imageSrcSet = imageSizes.map(width => {
    return "".concat(displayImage.src, "&width=").concat(width, " ").concat(width, "w");
  }).join(",");
  if (aspectratio <= 1) {
    maxWidthImage = parseInt(maxHeightImage) * aspectratio;
  } else {
    maxHeightImage = parseInt(maxWidthImage) / aspectratio;
  }
  var maxWidthImageFloat = maxWidthImage * 1.0;
  var getWrapperStyles = () => {
    return {
      '--padding-top': "".concat(maxHeightImage / maxWidthImageFloat * 100, "%"),
      '--max-height': "".concat(maxHeightImage, "px"),
      '--max-width': "".concat(maxWidthImage, "px")
    };
  };
  var getImageStyle = () => {
    return {
      objectFit: "".concat(imageFit ? imageFit : 'cover'),
      aspectRatio: "".concat(aspectratio)
    };
  };
  var css = "\n  .responsive-image__wrapper:before {\n    content: '';\n    width: 100%;\n    display: block;\n    padding-top: var(--padding-top);\n  }\n\n  .responsive-image__wrapper {\n      position: relative;\n      max-width: var(--max-width);\n      max-height: var(--max-height);\n      border-radius: 12px;\n  }\n\n  .responsive-image__image {\n      position: absolute;\n      top: 0;\n      height: 100%;\n      left: 0;\n      width: 100%;\n      object-fit: cover;\n      border-radius: 12px;\n  }";
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    id: "ImageWrapper-".concat(image_id, "-").concat(generated_image_id),
    "data-image-id": image_id,
    className: "responsive-image__wrapper",
    style: getWrapperStyles()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("img", {
    id: "Image-".concat(image_id, "-").concat(generated_image_id),
    className: "responsive-image__image",
    src: displayImage.src,
    load: "lazy",
    srcSet: imageSrcSet,
    "data-widths": "[".concat(imageSizes, "]"),
    "data-aspectratio": aspectratio,
    "data-sizes": "auto",
    tabIndex: "-1",
    style: getImageStyle()
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("style", null, css)));
});

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/addon-product-group.js"
/*!****************************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/addon-product-group.js ***!
  \****************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @headlessui/react */ "./node_modules/@headlessui/react/dist/components/checkbox/checkbox.js");
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @headlessui/react */ "./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js");
/* harmony import */ var _addon_product_selector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./addon-product-selector */ "./js/components/react/product-setup-drawer.js/addon-product-selector.js");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./store */ "./js/components/react/product-setup-drawer.js/store.js");
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! lucide-react */ "./node_modules/lucide-react/dist/esm/icons/chevron-down.js");
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! lucide-react */ "./node_modules/lucide-react/dist/esm/icons/chevron-up.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils */ "./js/components/react/product-setup-drawer.js/utils.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }


// import ProductRadioOption from "./required-product-selector";





var ProductGroup = _ref => {
  var {
    groupId,
    group,
    isRequired,
    syncQuantity
  } = _ref;
  var currentStep = (0,_store__WEBPACK_IMPORTED_MODULE_5__.productSetupStore)(state => state.currentStep);
  var selectedVariants = (0,_store__WEBPACK_IMPORTED_MODULE_5__.productSetupStore)(state => state.selectedVariants || []);
  var updateVariant = (0,_store__WEBPACK_IMPORTED_MODULE_5__.productSetupStore)(state => state.updateVariant);
  var removeVariant = (0,_store__WEBPACK_IMPORTED_MODULE_5__.productSetupStore)(state => state.removeVariant);
  var options = Array.isArray(group === null || group === void 0 ? void 0 : group.options) ? group.options : [];
  var answers = Array.isArray(group === null || group === void 0 ? void 0 : group.answers) ? group.answers : [];
  var isChecked = productId => selectedVariants === null || selectedVariants === void 0 ? void 0 : selectedVariants.some(v => v.productId === productId && v.groupId === groupId);
  //console.log("selectedVariants --->", selectedVariants);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__.Disclosure, {
    className: "disclosure-one"
  }, _ref2 => {
    var {
      open
    } = _ref2;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "tw-flex tw-flex-col tw-rounded-lg",
      style: {
        borderRadius: "8px",
        border: "1px solid #E5E5E5",
        background: "#FFF"
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__.Disclosure.Button, {
      as: "div",
      className: "tw-w-full tw-px-[12px] tw-pt-[12px] tw-flex tw-flex-col tw-gap-[8px] tw-cursor-pointer ".concat(open ? "tw-pb-[8px]" : "tw-pb-[12px]")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "tw-w-full tw-flex tw-justify-between tw-items-start"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("h3", {
      className: "tw-w-auto tw-text-[15px] tw-font-medium tw-text-black"
    }, group.title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
      className: "tw-w-[16px] tw-h-[16px] tw-p-0 tw-flex tw-items-center tw-justify-center"
    }, open ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(lucide_react__WEBPACK_IMPORTED_MODULE_7__["default"], {
      size: "16px"
    }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(lucide_react__WEBPACK_IMPORTED_MODULE_6__["default"], {
      size: "16px"
    })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_3__.Disclosure.Panel, {
      className: "tw-p-[12px]"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
      className: "tw-flex tw-flex-col tw-gap-[12px]"
    }, options.map(option => {
      var _option$variants;
      var isOutOfStock = !(option !== null && option !== void 0 && (_option$variants = option.variants) !== null && _option$variants !== void 0 && (_option$variants = _option$variants[0]) !== null && _option$variants !== void 0 && _option$variants.available);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.Checkbox, {
        key: option.id,
        checked: isChecked(option.productId),
        disabled: isOutOfStock,
        onChange: checked => {
          var _option$variants2;
          var firstVariant = option === null || option === void 0 || (_option$variants2 = option.variants) === null || _option$variants2 === void 0 ? void 0 : _option$variants2[0];
          if (checked) {
            var _firstVariant$availab;
            if (!firstVariant) return;
            updateVariant(currentStep, groupId, _objectSpread(_objectSpread({}, firstVariant), {}, {
              id: firstVariant.id,
              productId: option.productId,
              quantity: 1,
              availableInventory: (_firstVariant$availab = firstVariant.availableInventory) !== null && _firstVariant$availab !== void 0 ? _firstVariant$availab : 0,
              priceWithoutCurrency: (0,_utils__WEBPACK_IMPORTED_MODULE_8__.formatPrice)(firstVariant.priceWithoutCurrency),
              compareAtPrice: (0,_utils__WEBPACK_IMPORTED_MODULE_8__.formatPrice)(firstVariant.compareAtPrice),
              groupTitle: group.title,
              isRequired,
              syncQuantity
            }));
          } else {
            removeVariant(currentStep, groupId, option.productId, isRequired);
          }
        },
        className: "tw-w-full ".concat(isOutOfStock ? " tw-cursor-not-allowed" : "")
      }, _ref3 => {
        var {
          checked
        } = _ref3;
        return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
          className: isOutOfStock ? "tw-pointer-events-none" : ""
        }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_addon_product_selector__WEBPACK_IMPORTED_MODULE_4__["default"], {
          checked: checked,
          product: option,
          groupId: groupId,
          groupTitle: group.title,
          isRequired: isRequired,
          syncQuantity: syncQuantity,
          isOutOfStock: isOutOfStock,
          showQuantitySelector: option.showQuantitySelector
        }));
      });
    }))));
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductGroup);

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/addon-product-selector.js"
/*!*******************************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/addon-product-selector.js ***!
  \*******************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils */ "./js/components/react/product-setup-drawer.js/utils.js");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./store */ "./js/components/react/product-setup-drawer.js/store.js");
/* harmony import */ var _quantity_selector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./quantity-selector */ "./js/components/react/product-setup-drawer.js/quantity-selector.js");
/* harmony import */ var _variant_selector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./variant-selector */ "./js/components/react/product-setup-drawer.js/variant-selector.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }





function ProductRadioOption(_ref) {
  var _product$variants, _ref2, _ref3, _selectedVariant$pric, _product$variants2, _product$variants3, _safeVariant$availabl2;
  var {
    checked,
    product,
    groupId,
    groupTitle,
    isRequired,
    syncQuantity,
    isOutOfStock,
    showQuantitySelector
  } = _ref;
  var currentStep = (0,_store__WEBPACK_IMPORTED_MODULE_3__.productSetupStore)(state => state.currentStep);
  var selectedVariants = (0,_store__WEBPACK_IMPORTED_MODULE_3__.productSetupStore)(state => state.selectedVariants);
  var updateVariant = (0,_store__WEBPACK_IMPORTED_MODULE_3__.productSetupStore)(state => state.updateVariant);
  // const removeVariant = productSetupStore((state) => state.removeVariant);

  var hasVariants = !!(product !== null && product !== void 0 && product.hasVariants);
  //  console.log("checked", checked);
  var groupSelectedVariant = (0,_store__WEBPACK_IMPORTED_MODULE_3__.productSetupStore)(state => state.selectedVariants.find(v => v.step === currentStep && v.groupId === groupId && v.productId === product.productId));
  var selectedVariant = groupSelectedVariant !== null && groupSelectedVariant !== void 0 ? groupSelectedVariant : null;
  var selectedId = selectedVariant == null ? "" : selectedVariant.id === null ? null : selectedVariant.id;
  var safeVariant = groupSelectedVariant !== null && groupSelectedVariant !== void 0 ? groupSelectedVariant : hasVariants ? (_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants[0] : product;
  var handleVariantQuantityChange = (variantId, nextQty) => {
    var existingVariant = selectedVariants.find(v => v.step === currentStep && v.groupId === groupId && v.productId === product.productId);
    if (!existingVariant) {
      var _safeVariant$availabl;
      // create new entry in store
      updateVariant(currentStep, groupId, _objectSpread(_objectSpread({}, safeVariant), {}, {
        id: safeVariant === null || safeVariant === void 0 ? void 0 : safeVariant.id,
        productId: product.productId,
        groupId,
        step: currentStep,
        quantity: nextQty,
        availableInventory: (_safeVariant$availabl = safeVariant === null || safeVariant === void 0 ? void 0 : safeVariant.availableInventory) !== null && _safeVariant$availabl !== void 0 ? _safeVariant$availabl : 0,
        priceWithoutCurrency: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.formatPrice)(safeVariant.priceWithoutCurrency),
        compareAtPrice: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.formatPrice)(safeVariant.compareAtPrice),
        groupTitle,
        isRequired,
        syncQuantity
      }));
      return;
    }

    // update existing
    updateVariant(currentStep, groupId, _objectSpread(_objectSpread({}, existingVariant), {}, {
      quantity: nextQty
    }));
  };

  // ✅ Determine price to display
  var displayPrice = (_ref2 = (_ref3 = (_selectedVariant$pric = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.priceWithoutCurrency) !== null && _selectedVariant$pric !== void 0 ? _selectedVariant$pric : product === null || product === void 0 || (_product$variants2 = product.variants) === null || _product$variants2 === void 0 || (_product$variants2 = _product$variants2.find(v => v.id === selectedId)) === null || _product$variants2 === void 0 ? void 0 : _product$variants2.priceWithoutCurrency) !== null && _ref3 !== void 0 ? _ref3 : product === null || product === void 0 || (_product$variants3 = product.variants) === null || _product$variants3 === void 0 || (_product$variants3 = _product$variants3[0]) === null || _product$variants3 === void 0 ? void 0 : _product$variants3.priceWithoutCurrency) !== null && _ref2 !== void 0 ? _ref2 : null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-box-border tw-flex tw-flex-row tw-items-start tw-gap-[12px] tw-rounded-[8px] tw-p-[16px] tw-w-full tw-cursor-pointer ".concat(checked ? "tw-bg-[#027DB329]" : "tw-bg-[#F4F6F8]"),
    style: {
      border: checked ? "1px solid #027DB3" : "1px solid #E5E5E5"
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-items-start tw-pt-[2px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    style: {
      border: checked ? "1px solid #027DB3" : "1px solid #E5E5E5"
    },
    className: "tw-w-[18px] tw-h-[18px] tw-rounded-[4px] tw-border tw-flex tw-items-center tw-justify-center tw-transition-colors ".concat(checked ? "tw-bg-[#027DB3]" : "tw-bg-white")
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("svg", {
    className: "tw-transition-opacity ".concat(checked ? "tw-opacity-100" : "tw-opacity-0"),
    width: "12",
    height: "10",
    viewBox: "0 0 12 10",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("path", {
    d: "M1 5L4 8L11 1",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-gap-[10px] tw-flex-1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: " tw-text-[15px] tw-break-words tw-leading-[16px] ".concat(checked ? "tw-text-[#000000]" : "tw-text-[#666666]")
  }, product ? product.title : noneOptionTitle), checked && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-flex tw-gap-[8px]"
  }, checked && showQuantitySelector !== false && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_quantity_selector__WEBPACK_IMPORTED_MODULE_4__["default"], {
    isOption: true,
    variantId: selectedId || (safeVariant === null || safeVariant === void 0 ? void 0 : safeVariant.id),
    maxQuantity: Number((_safeVariant$availabl2 = safeVariant === null || safeVariant === void 0 ? void 0 : safeVariant.availableInventory) !== null && _safeVariant$availabl2 !== void 0 ? _safeVariant$availabl2 : 0),
    showQuantitySelector: showQuantitySelector,
    onChange: nextQty => handleVariantQuantityChange(groupSelectedVariant.id, nextQty)
  }), checked && hasVariants && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement(_variant_selector__WEBPACK_IMPORTED_MODULE_5__["default"], {
    variants: product.variants,
    selectedVariantId: selectedId,
    onChange: variant => {
      var _selectedVariant$quan;
      updateVariant(currentStep, groupId, _objectSpread(_objectSpread({}, variant), {}, {
        productId: product.productId,
        groupId,
        step: currentStep,
        quantity: (_selectedVariant$quan = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantity) !== null && _selectedVariant$quan !== void 0 ? _selectedVariant$quan : 1,
        availableInventory: variant.availableInventory,
        groupTitle,
        isRequired,
        syncQuantity
      }));
    }
  }))), isOutOfStock && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("span", {
    className: "tw-text-red-500 tw-text-[13px] tw-font-medium tw-mt-[4px]"
  }, "Out of stock"), displayPrice != null && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1___default().createElement("div", {
    className: "tw-text-[16px] tw-font-semibold tw-whitespace-nowrap tw-pt-[2px] ".concat(checked ? "tw-text-[#008A09]" : "tw-text-[#2E7D32]")
  }, "+ ", (0,_utils__WEBPACK_IMPORTED_MODULE_2__.formatPrice)(displayPrice, true, false, true)));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductRadioOption);

// useEffect(() => {
//   if (!checked) return;
//   const existingVariant = selectedVariants.find(
//     (v) =>
//       v.step === currentStep &&
//       v.groupId === groupId &&
//       v.productId === product.productId
//   );

//   // If already stored → do nothing
//   if (existingVariant) return;

//   // If product has variants → take first variant
//   const firstVariant = product?.variants?.[0];

//   if (!firstVariant) return;

//   updateVariant(currentStep, groupId, {
//     ...firstVariant,
//     id: firstVariant.id,
//     productId: product.productId,
//     groupId,
//     step: currentStep,
//     quantity: 1,
//     availableInventory: firstVariant.availableInventory ?? 0,
//     groupTitle,
//     isRequired,
//     syncQuantity,
//   });

// }, [
//   checked,
//   currentStep,
// ]);

// useEffect(() => {
//   if (checked) return;

//   removeVariant(currentStep, groupId, product.productId, isRequired);
// }, [checked]);

// useEffect(() => {
//   console.log("selected variants ------> : ",selectedVariants )
// },[selectedVariants])

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/drawer.js"
/*!***************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/drawer.js ***!
  \***************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports MainProduct, StepIndicator, StepContent, StepFooter */
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./store */ "./js/components/react/product-setup-drawer.js/store.js");
/* harmony import */ var _ResponsiveImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../ResponsiveImage */ "./js/components/react/ResponsiveImage.js");
/* harmony import */ var _quantity_selector__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./quantity-selector */ "./js/components/react/product-setup-drawer.js/quantity-selector.js");
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../api */ "./js/components/api.js");
/* harmony import */ var _product_groups__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./product-groups */ "./js/components/react/product-setup-drawer.js/product-groups.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utils */ "./js/components/react/product-setup-drawer.js/utils.js");



var _excluded = ["_p", "_compareAtPrice"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }








var MainProduct = _ref => {
  var _window$custom;
  var {
    data
  } = _ref;
  var model = ((_window$custom = window.custom) === null || _window$custom === void 0 ? void 0 : _window$custom.locales.modelNumber) || "Model";
  if (!data) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    style: {
      borderBottom: "1px solid #DDDDDD"
    },
    className: "tw-w-[100%] tw-py-[16px] tw-px-[16px] lg:tw-px-[30px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-w-[100%] tw-h-full tw-flex tw-justify-start tw-gap-[16px] tw-rounded-[12px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    style: {
      border: "1px solid #E5E5E5"
    },
    className: "tw-w-[120px] tw-h-[120px] tw-rounded-[12px] tw-flex-shrink-0 tw-relative"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(_ResponsiveImage__WEBPACK_IMPORTED_MODULE_5__["default"], {
    aspectratio: 1,
    image: data.image,
    settings: {
      imageFit: "object-cover"
    }
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-h-full tw-w-[100%] tw-justify-between tw-p-0 tw-m-0"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-w-[100%] tw-gap-[4px] tw-p-0 tw-m-0 tw-overflow-hidden"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("h3", {
    className: "tw-text-[15px] tw-font-bold leading-18px tw-text-[#000000] tw-m-0 tw-line-clamp-2"
  }, data.title), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("p", {
    className: "tw-text-[12px] tw-font-bold tw-text-[#666666] tw-p-0 tw-m-0 leading-0 tw-break-all"
  }, model, ": ", data.description)), data.showQuantitySelector != false && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(_quantity_selector__WEBPACK_IMPORTED_MODULE_6__["default"], null))));
};
var StepIndicator = _ref2 => {
  var _steps$currentStep;
  var {
    steps
  } = _ref2;
  var currentStep = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.currentStep);
  if (!Array.isArray(steps)) return null;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    style: {
      borderBottom: Array.isArray(steps) && steps.length > 0 ? "1px solid #DDDDDD" : "none"
    },
    className: "tw-bg-[#FFFFFF] tw-py-[16px] tw-px-[16px] lg:tw-px-[30px] tw-flex tw-flex-col tw-gap-[16px] tw-sticky tw-top-0 tw-z-[31474836479] tw-border-b tw-border-gray-200"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-flex tw-w-full tw-justify-start tw-items-center tw-gap-[16px] lg:tw-grid lg:tw-grid-cols-[50%_50%]"
  }, steps.map((step, index) => {
    var isActive = currentStep === index;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
      key: index,
      className: "tw-flex tw-items-center tw-gap-[4px] lg:tw-gap-xs"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
      style: {
        backgroundColor: isActive ? "#027DB3" : "#FFFFFF",
        border: isActive ? "none" : "1px solid #E5E5E5",
        color: isActive ? "#FFFFFF" : "#323E46"
      },
      className: "tw-w-[32px] tw-h-[32px] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-semibold"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("span", {
      className: "tw-text-[14px] lg:tw-text-[15px] tw-font-medium tw-leading-[125%]"
    }, index + 1)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("span", {
      className: "tw-whitespace-nowrap tw-text-[14px] lg:tw-text-[15px] tw-leading-[18px] tw-font-medium tw-tracking-[-0.14px] ".concat(isActive ? "tw-text-[#027DB3]" : "tw-text-[#323E46]")
    }, step.heading));
  })), ((_steps$currentStep = steps[currentStep]) === null || _steps$currentStep === void 0 ? void 0 : _steps$currentStep.description) && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("p", {
    className: "tw-m-0 tw-text-[14px] lg:tw-text-[15px] tw-leading-[24px] tw-font-bold tw-text-[#666666]"
  }, steps[currentStep].description));
};
var StepContent = _ref3 => {
  var {
    children
  } = _ref3;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-flex-1 tw-overflow-y-auto tw-p-md"
  }, children);
};
var StepFooter = _ref4 => {
  var _window$custom2, _window$custom3, _window$custom4, _window$custom5;
  var {
    totalSteps,
    mainProduct = null,
    isRequired
  } = _ref4;
  var footerTextOne = ((_window$custom2 = window.custom) === null || _window$custom2 === void 0 ? void 0 : _window$custom2.locales.footerTextOne) || " ";
  var footerTextTwo = ((_window$custom3 = window.custom) === null || _window$custom3 === void 0 ? void 0 : _window$custom3.locales.footerTextTwo) || " ";
  var nextLabel = ((_window$custom4 = window.custom) === null || _window$custom4 === void 0 ? void 0 : _window$custom4.locales.continue) || " ";
  var submitLabel = ((_window$custom5 = window.custom) === null || _window$custom5 === void 0 ? void 0 : _window$custom5.locales.addToCart) || " ";

  // Get all values directly from store
  var currentStep = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.currentStep);
  var selectedVariants = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.selectedVariants);
  var totalPrice = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.totalPrice);
  var totalCompareAtPrice = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.totalCompareAtPrice);
  var isLoading = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.isLoading);
  var isDisabled = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.isDisabled);
  var nextStep = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.nextStep);
  var isLastStep = currentStep === totalSteps - 1;
  var mainProductQuantity = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.mainProductQuantity);
  var mainProductPrice = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.baseUnitPrice);
  var missedRequiredGroupIds = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.missedRequiredGroupIds);
  var setIsRequiredInfoFilled = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.setIsRequiredInfoFilled);
  var addons = selectedVariants.filter(v => v && v.id && !v.isRequired);

  // useEffect(() => {
  //   console.log("selectedVariants : ", selectedVariants);
  // }, [selectedVariants])

  //helper for add to cart
  var buildMainProductProperties = selectedVariants => {
    return selectedVariants.reduce((properties, variant) => {
      var {
        groupTitle: question,
        title: answer,
        sku: sku,
        productTitle,
        compareAtPrice,
        id,
        priceWithoutCurrency,
        discountPercentage
      } = variant;
      var comparePriceValue = discountPercentage > 0 ? compareAtPrice : priceWithoutCurrency;
      var answerKey = productTitle ? "".concat(productTitle, " :: ").concat(answer) : answer;

      // Skip only if this object has a price (actual product line)
      if (priceWithoutCurrency && id && variant.isRequired && variant.isSurcharge !== true) {
        // console.log("1st one");
        properties = _objectSpread(_objectSpread({}, properties), {}, {
          ["_product_".concat(answerKey)]: "".concat(sku, "::").concat((0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(priceWithoutCurrency, true)),
          "_p": parseFloat(properties["_p"] || 0) + parseFloat(priceWithoutCurrency),
          "_compareAtPrice": parseFloat(properties["_compareAtPrice"] || 0) + parseFloat(priceWithoutCurrency || 0)
        });
      }
      // for surcharge answers
      else if (priceWithoutCurrency && String(id) && variant.isRequired && variant.isSurcharge === true) {
        var _answerKey = (answer || "").split("::")[0].trim();
        // console.log("2nd one");
        properties = _objectSpread(_objectSpread({}, properties), {}, {
          ["_surcharge_".concat(question)]: "".concat(_answerKey, "::").concat((0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(priceWithoutCurrency, true)),
          "_p": parseFloat(properties["_p"] || 0) + parseFloat(priceWithoutCurrency),
          "_compareAtPrice": parseFloat(properties["_compareAtPrice"] || 0) + parseFloat(priceWithoutCurrency || 0)
        });
      } else if (!priceWithoutCurrency && String(id) != null && variant.isSurcharge !== true) {
        // console.log("3rd one ");
        properties = _objectSpread(_objectSpread({}, properties), {}, {
          ["_answer_".concat(question)]: answer
        });
      } else if (!priceWithoutCurrency && String(id) != null && variant.isSurcharge === true) {
        var _answerKey2 = (answer || "").split("::")[0].trim();
        //console.log("4th one ");
        properties = _objectSpread(_objectSpread({}, properties), {}, {
          ["_answer_".concat(question)]: _answerKey2
        });
      }
      return properties;
    }, {});
  };

  // Add items to cart using Shopify Cart AJAX API
  var addToCart = /*#__PURE__*/function () {
    var _ref5 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* () {
      var mainVariantId = mainProduct === null || mainProduct === void 0 ? void 0 : mainProduct.selectedVariantId;

      // Build items array for cart/add.js
      var items = addons.map(_ref6 => {
        var {
          id,
          quantity
        } = _ref6;
        return {
          id,
          quantity
        };
      });

      // 1. Add the main product first (parent)
      if (mainVariantId) {
        var builtProperties = buildMainProductProperties(selectedVariants);
        var {
            _p,
            _compareAtPrice
          } = builtProperties,
          rest = (0,_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__["default"])(builtProperties, _excluded);
        var mainProductData = {
          id: mainVariantId,
          quantity: mainProductQuantity,
          properties: _objectSpread(_objectSpread({}, rest), {}, {
            _is_parent: "true",
            _p,
            _compareAtPrice
          })
        };
        mainProductData.properties["_p"] = (0,_utils__WEBPACK_IMPORTED_MODULE_9__.getPrice)(parseFloat(mainProductData.properties["_p"] || 0) + mainProductPrice, mainVariantId);
        // mainProductData.properties["_compareAtPriceTest"] =
        //   parseFloat(mainProductData.properties["_compareAtPrice"] || 0) +
        //   parseFloat(mainProduct.compareAtPrice || 0);     
        var compareAt = parseFloat(mainProduct.compareAtPrice || 0);
        var price = parseFloat(mainProductPrice || 0);
        if (compareAt > price) {
          mainProductData.properties["_compareAtPrice"] = (0,_utils__WEBPACK_IMPORTED_MODULE_9__.getPrice)(parseFloat(mainProductData.properties["_compareAtPrice"] || 0) + compareAt, mainVariantId);
        } else {
          mainProductData.properties["_compareAtPrice"] = null;
        }
        items.push(mainProductData);
      }
      // console.log("items : ", items);
      if (items.length === 0) {
        console.warn("No valid items to add to cart");
        return;
      }

      // Collect sections to bundle (for cart drawer refresh)
      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: {
          sections: sectionsToBundle
        }
      }));

      // Set loading state
      _store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore.getState().setLoading(true);
      try {
        var _parsedState$items, _window$FoxTheme, _window$closeDrawer, _window;
        var response = yield fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items,
            sections: sectionsToBundle,
            sections_url: window.location.pathname
          })
        });
        if (!response.ok) {
          var errorData = yield response.json();
          throw new Error(errorData.description || 'Failed to add items to cart');
        }
        var parsedState = yield response.json();

        // Use parsedState directly — sections are rendered fresh from this same add call.
        // item_count must be > 0 so onCartUpdate shows the cart body, not the empty state.
        var cartJson = {
          sections: parsedState.sections,
          item_count: ((_parsedState$items = parsedState.items) !== null && _parsedState$items !== void 0 ? _parsedState$items : []).length || 1
        };

        // Publish cart update event to refresh cart UI
        if ((_window$FoxTheme = window.FoxTheme) !== null && _window$FoxTheme !== void 0 && (_window$FoxTheme = _window$FoxTheme.pubsub) !== null && _window$FoxTheme !== void 0 && _window$FoxTheme.publish) {
          window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
            cart: cartJson
          });
        }

        // Reset the store after successful add
        _store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore.getState().resetStore();

        // Close the product setup drawer
        (_window$closeDrawer = (_window = window).closeDrawer) === null || _window$closeDrawer === void 0 || _window$closeDrawer.call(_window);

        // Open the cart drawer
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer !== null && cartDrawer !== void 0 && cartDrawer.show) {
          cartDrawer.show();
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        // productSetupStore.getState().setErrors({ cart: error.message });
      } finally {
        _store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore.getState().setLoading(false);
      }
    });
    return function addToCart() {
      return _ref5.apply(this, arguments);
    };
  }();

  // Handle next/submit button click
  var handleNextClick = () => {
    if (isRequired) {
      var missingCount = missedRequiredGroupIds.length;
      if (missingCount > 0) {
        setIsRequiredInfoFilled(true);
        // scroll to first error group
        setTimeout(() => {
          var _document$querySelect;
          (_document$querySelect = document.querySelector('[data-error-group="true"]')) === null || _document$querySelect === void 0 || _document$querySelect.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 100);
        return;
      }
    }
    if (isLastStep) {
      addToCart();
    } else {
      nextStep();
    }
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    style: {
      border: "1px solid #D1D5DB"
    },
    className: "tw-z-[31474836479] tw-flex tw-flex-col tw-sticky tw-bottom-0 tw-px-[16px] lg:tw-px-[30px] tw-pt-[16px] tw-pb-[30px] tw-gap-[16px] tw-bg-[#FFFFFF]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-gap-[4px] tw-items-start"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-w-full tw-flex tw-leading-[28px] tw-justify-between"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("span", {
    className: "tw-text-[#000000] tw-text-[18px] tw-font-bold"
  }, footerTextOne), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-flex tw-gap-[8px]"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("span", {
    className: "tw-text-[#D32F2F] tw-place-items-center tw-text-[16px] tw-font-bold"
  }, (0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(totalPrice, true, false, true)), (0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(mainProduct.compareAtPrice) > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("span", {
    className: "tw-flex tw-place-items-center tw-text-[#666666] tw-text-[12px] tw-font-semibold tw-line-through"
  }, (0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(totalCompareAtPrice, true, false, true)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("p", {
    className: " tw-leading-[20px] tw-m-0 tw-text-[12px] tw-font-medium tw-text-[#000000]"
  }, footerTextTwo)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("button", {
    onClick: handleNextClick,
    className: "btn btn--white btn--white-product-card",
    disabled: isLoading || isDisabled
  }, isLoading && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("svg", {
    className: "tw-animate-spin tw-h-5 tw-w-5",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("circle", {
    className: "tw-opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    strokeWidth: "4"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("path", {
    className: "tw-opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("span", {
    className: "btn__text"
  }, isLastStep ? submitLabel : nextLabel)));
};

// Loading skeleton component matching the actual UI structure
var DrawerSkeleton = () => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[calc(100vh-58px)] tw-flex tw-flex-col tw-bg-white"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  style: {
    borderBottom: "1px solid #DDDDDD"
  },
  className: "tw-h-[155px] lg:tw-h-[132px] tw-px-[16px] tw-pt-[16px] tw-pb-[30px] lg:tw-px-[30px] lg:tw-p-[16px]"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-w-full tw-flex tw-justify-start tw-gap-[16px]"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-w-[100px] tw-h-[100px] tw-bg-gray-200 tw-rounded-lg tw-flex-shrink-0 tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-flex tw-flex-col tw-flex-1 tw-justify-start tw-gap-2"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[18px] tw-bg-gray-200 tw-rounded tw-w-4/5 tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[12px] tw-bg-gray-200 tw-rounded tw-w-24 tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[12px] tw-bg-gray-200 tw-rounded tw-w-20 tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[16px] tw-bg-gray-200 tw-rounded tw-w-10 tw-animate-pulse !tw-block"
})))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-bg-white tw-sticky tw-top-0 tw-z-[31474836479] tw-border-b tw-border-gray-200"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-grid tw-grid-cols-[50%_50%] tw-p-[16px] lg:tw-px-[30px]"
}, [0, 1].map(index => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  key: index,
  className: "tw-w-full tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-start tw-items-center tw-gap-[4px] lg:tw-gap-xs"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-w-[32px] tw-h-[32px] tw-bg-gray-200 tw-rounded-full tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[14px] tw-bg-gray-200 tw-rounded tw-w-16 lg:tw-w-[60%] tw-animate-pulse !tw-block"
})))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-px-[16px] lg:tw-px-[30px] tw-pb-[16px] tw-space-y-[8px]"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[16px] tw-w-[200px] tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[14px] tw-w-full tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[14px] tw-w-[85%] tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
}))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-space-y-[32px] tw-flex-1 tw-overflow-y-auto tw-px-[16px] lg:tw-px-[30px] tw-py-[20px]"
}, [0, 1, 2].map(index => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  key: index,
  className: "tw-border tw-border-gray-200 tw-rounded-lg tw-p-[16px] tw-space-y-[12px]"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[16px] tw-w-[90%] tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[14px] tw-w-[120px] tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
})))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  style: {
    border: "1px solid #D1D5DB"
  },
  className: "tw-min-h-[130px] tw-z-[31474836479] tw-flex tw-flex-col tw-sticky tw-bottom-0 tw-px-[16px] lg:tw-px-[30px] tw-pt-[16px] tw-pb-[30px] tw-gap-[8px] tw-bg-white"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-flex tw-justify-between tw-items-start"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-space-y-[6px]"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[14px] tw-w-[120px] tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[12px] tw-w-[220px] tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
})), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-space-y-[6px] tw-text-right"
}, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[16px] tw-w-[90px] tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
}), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[12px] tw-w-[70px] tw-bg-gray-200 tw-rounded tw-animate-pulse !tw-block"
}))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
  className: "tw-h-[48px] tw-w-full tw-rounded-full tw-bg-gray-300 tw-animate-pulse !tw-block"
})));
var ProductSetupDrawer = _ref7 => {
  var _dataWithStep$current, _dataWithStep$current2, _dataWithStep$current3;
  var {
    handle,
    selectedVariantId: _selectedVariantId,
    quantity = 1
  } = _ref7;
  var currentStep = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.currentStep);
  var setLoading = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.setLoading);
  var setPriceDetails = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.setPriceDetails);
  var mainProductQuantity = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.mainProductQuantity);
  var setMainProductQuantity = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.setMainProductQuantity);
  var setMainProductAvailableInventory = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.setMainProductAvailableInventory);
  var setSurchargeForCaliforniaPercentage = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.setSurchargeForCaliforniaPercentage);
  var setIsRequiredInfoFilled = (0,_store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore)(state => state.setIsRequiredInfoFilled);

  // Single state for API data
  var [apiData, setApiData] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(null);

  // Fetch data only when handle changes
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    var isCancelled = false;

    // Reset selection state whenever a new product is opened
    _store__WEBPACK_IMPORTED_MODULE_4__.productSetupStore.getState().resetForNewProduct();
    setApiData(null);
    var fetchData = /*#__PURE__*/function () {
      var _ref8 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(function* () {
        setLoading(true);
        try {
          var res = yield (0,_api__WEBPACK_IMPORTED_MODULE_7__.fetchProductSetupData)(handle);
          if (!isCancelled) {
            setApiData(res);
          }
        } catch (error) {
          console.error('Error fetching product setup data:', error);
        } finally {
          if (!isCancelled) {
            setLoading(false);
          }
        }
      });
      return function fetchData() {
        return _ref8.apply(this, arguments);
      };
    }();
    fetchData();
    return () => {
      isCancelled = true;
    };
  }, [handle, setLoading]);

  // to set price details in zustand store
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (!apiData || !apiData.main) return;
    var mainFromApi = apiData.main || {};
    var totalPrice = (0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(mainFromApi.discountedPrice);
    var totalCompareAtPrice = (0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(mainFromApi.compareAtPrice);
    // if (
    //   mainFromApi.priceWithoutCurrency &&
    //   mainFromApi.discountedPrice &&
    //   mainFromApi.priceWithoutCurrency !== mainFromApi.discountedPrice
    // ) {
    //   totalCompareAtPrice = formatPrice(mainFromApi.priceWithoutCurrency);
    // }
    setMainProductQuantity(quantity);
    setPriceDetails(totalPrice, totalCompareAtPrice);
    // null means no inventory tracking (or continue selling policy) → unlimited
    var availableInventory = mainFromApi.availableInventory != null ? mainFromApi.availableInventory : Infinity;
    setMainProductAvailableInventory(availableInventory);
  }, [apiData]);

  // Compute mainProduct from apiData + props (no separate state needed)
  var mainProduct = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    var _mainFromApi$showQuan, _mainFromApi$surcharg;
    if (!apiData) return null;
    var mainFromApi = apiData.main || {};
    var price = (0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(mainFromApi.discountedPrice) || 0;
    var compareAtPrice = (0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(mainFromApi.compareAtPrice) || 0;

    // if (
    //   mainFromApi.priceWithoutCurrency &&
    //   mainFromApi.discountedPrice &&
    //   Number(mainFromApi.priceWithoutCurrency) !== Number(mainFromApi.discountedPrice)
    // ) {
    //   compareAtPrice = formatPrice(mainFromApi.priceWithoutCurrency);
    // }

    return {
      title: mainFromApi.title || '',
      image: mainFromApi.image || null,
      description: mainFromApi.description || null,
      selectedVariantId: mainFromApi.id || null,
      priceWithoutCurrency: price || 0,
      compareAtPrice: compareAtPrice || 0,
      discountPercentage: mainFromApi.discountPercentage || 0,
      showQuantitySelector: (_mainFromApi$showQuan = mainFromApi.showQuantitySelector) !== null && _mainFromApi$showQuan !== void 0 ? _mainFromApi$showQuan : null,
      surchargeForCaliforniaPercentage: (_mainFromApi$surcharg = mainFromApi.surchargeForCaliforniaPercentage) !== null && _mainFromApi$surcharg !== void 0 ? _mainFromApi$surcharg : null
    };
  }, [apiData, mainProductQuantity]);

  // storing surcharge percentage in product store for later use in product groups
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    setSurchargeForCaliforniaPercentage((mainProduct === null || mainProduct === void 0 ? void 0 : mainProduct.surchargeForCaliforniaPercentage) || 0);
  }, [mainProduct, setSurchargeForCaliforniaPercentage]);
  var calculatedSurcharge = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    if (!(apiData !== null && apiData !== void 0 && apiData.main)) return 0;
    var price = (0,_utils__WEBPACK_IMPORTED_MODULE_9__.formatPrice)(apiData.main.discountedPrice) || 0;
    var surchargeForCaliforniaPercentage = apiData.main.surchargeForCaliforniaPercentage;
    var isLowOrMissingSurcharge = surchargeForCaliforniaPercentage == null || surchargeForCaliforniaPercentage < 1;
    if (!isLowOrMissingSurcharge && price > 0) {
      return price * surchargeForCaliforniaPercentage / 100;
    }
    return 0;
  }, [apiData]);
  var steps = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => (apiData === null || apiData === void 0 ? void 0 : apiData.steps) || [], [apiData]);
  var dataWithStep = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(() => {
    var _apiData$main, _apiData$mandatory, _apiData$mandatory2, _apiData$addons;
    var data = [];
    if (!apiData) return data;
    var surchargePercentage = (_apiData$main = apiData.main) === null || _apiData$main === void 0 ? void 0 : _apiData$main.surchargeForCaliforniaPercentage;
    var shouldAddDefaultSurcharge = ((_apiData$mandatory = apiData.mandatory) === null || _apiData$mandatory === void 0 ? void 0 : _apiData$mandatory.isRequiredGroup) && surchargePercentage != null && surchargePercentage >= 1;
    var mandatoryProducts = [...(((_apiData$mandatory2 = apiData.mandatory) === null || _apiData$mandatory2 === void 0 ? void 0 : _apiData$mandatory2.products) || [])];
    var surchargeExists = mandatoryProducts.some(item => item.isSurcharge === true);
    if (shouldAddDefaultSurcharge && !surchargeExists) {
      mandatoryProducts.push({
        title: "Default California surcharge",
        noneOptionText: "",
        namespace: "mandatory",
        isSurcharge: true,
        answers: [{
          id: 0,
          title: "California::true"
        }, {
          id: 1,
          title: "Other States::false"
        }]
      });
    }
    if (mandatoryProducts.length || shouldAddDefaultSurcharge) {
      data.push({
        step: steps[0],
        products: mandatoryProducts,
        isRequired: apiData.mandatory.isRequiredGroup,
        syncQuantity: apiData.mandatory.syncQuantity
      });
    }
    if ((_apiData$addons = apiData.addons) !== null && _apiData$addons !== void 0 && (_apiData$addons = _apiData$addons.products) !== null && _apiData$addons !== void 0 && _apiData$addons.length) {
      data.push({
        step: steps[1],
        products: apiData.addons.products,
        isRequired: apiData.addons.isRequiredGroup,
        syncQuantity: apiData.addons.syncQuantity
      });
    }
    return data;
  }, [steps, apiData]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    setIsRequiredInfoFilled(false);
  }, [apiData, currentStep]);
  (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(() => {
    if (!apiData) return;
    window.custom = window.custom || {};
    window.custom.locales = apiData.locales;
  }, [apiData]);

  // Show skeleton while loading
  if (!apiData) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(DrawerSkeleton, null);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: " tw-z-[31474836479] tw-h-full tw-flex tw-flex-col tw-justify-between tw-gap-0 tw-bg-white"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(MainProduct, {
    data: mainProduct
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(StepIndicator, {
    steps: dataWithStep.map(d => d.step)
  })), dataWithStep.length ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement((react__WEBPACK_IMPORTED_MODULE_3___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(_product_groups__WEBPACK_IMPORTED_MODULE_8__["default"], {
    data: dataWithStep[currentStep].products,
    isRequired: (_dataWithStep$current = dataWithStep[currentStep]) === null || _dataWithStep$current === void 0 ? void 0 : _dataWithStep$current.isRequired,
    surchargeForCaliforniaPercentage: mainProduct === null || mainProduct === void 0 ? void 0 : mainProduct.surchargeForCaliforniaPercentage,
    syncQuantity: (_dataWithStep$current2 = dataWithStep[currentStep]) === null || _dataWithStep$current2 === void 0 ? void 0 : _dataWithStep$current2.syncQuantity,
    calculatedSurcharge: calculatedSurcharge
  })) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("div", {
    className: "tw-w-full tw-h-full tw-flex tw-justify-center tw-items-start tw-px-8 lg:tw-px-16"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("h5", {
    className: "tw-m-2 tw-text-[#666666] "
  }, "No customization found, ", /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement("br", null), " please add the product to cart")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_3___default().createElement(StepFooter, {
    totalSteps: dataWithStep.length || 1,
    mainProduct: mainProduct,
    isRequired: (_dataWithStep$current3 = dataWithStep[currentStep]) === null || _dataWithStep$current3 === void 0 ? void 0 : _dataWithStep$current3.isRequired
  }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductSetupDrawer);

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/product-groups.js"
/*!***********************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/product-groups.js ***!
  \***********************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _required_product_group__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./required-product-group */ "./js/components/react/product-setup-drawer.js/required-product-group.js");
/* harmony import */ var _addon_product_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./addon-product-group */ "./js/components/react/product-setup-drawer.js/addon-product-group.js");



var ProductGroups = _ref => {
  var {
    data,
    isRequired,
    surchargeForCaliforniaPercentage,
    syncQuantity,
    calculatedSurcharge
  } = _ref;
  if (!Array.isArray(data)) return null;
  var shouldShowSurcharge = isRequired && surchargeForCaliforniaPercentage != null && surchargeForCaliforniaPercentage >= 1;
  var filteredData = data.filter(group => {
    if (isRequired) {
      if (!shouldShowSurcharge && (group === null || group === void 0 ? void 0 : group.isSurcharge) === true) {
        return false; // hide this group
      }
    }
    return true;
  });
  //console.log("data: ", data);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-h-full tw-overflow-y-auto tw-py-[16px] tw-px-[16px] lg:tw-px-[30px] tw-gap-[8px]"
  }, filteredData.map((group, groupIndex) => {
    var {
      namespace: groupNameSpace
    } = group;
    var groupId = "".concat(groupNameSpace, "-").concat(groupIndex);
    var Component = isRequired ? _required_product_group__WEBPACK_IMPORTED_MODULE_1__["default"] : _addon_product_group__WEBPACK_IMPORTED_MODULE_2__["default"];
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(Component, {
      key: groupId,
      groupId: groupId,
      group: group,
      isRequired: isRequired,
      syncQuantity: syncQuantity
    });
  }));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductGroups);

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/quantity-selector.js"
/*!**************************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/quantity-selector.js ***!
  \**************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./store */ "./js/components/react/product-setup-drawer.js/store.js");


var QuantitySelector = _ref => {
  var _selectedVariants$fin, _selectedVariants$fin2;
  var {
    isOption = false,
    variantId = null,
    maxQuantity = Infinity,
    onChange
  } = _ref;
  var mainProductQuantity = (0,_store__WEBPACK_IMPORTED_MODULE_1__.productSetupStore)(state => state.mainProductQuantity);
  var setMainProductQuantity = (0,_store__WEBPACK_IMPORTED_MODULE_1__.productSetupStore)(state => state.setMainProductQuantity);
  var mainProductAvailableInventory = (0,_store__WEBPACK_IMPORTED_MODULE_1__.productSetupStore)(state => state.mainProductAvailableInventory);
  var selectedVariants = (0,_store__WEBPACK_IMPORTED_MODULE_1__.productSetupStore)(state => state.selectedVariants);
  var optionQuantity = (_selectedVariants$fin = (_selectedVariants$fin2 = selectedVariants.find(v => v.id === variantId)) === null || _selectedVariants$fin2 === void 0 ? void 0 : _selectedVariants$fin2.quantity) !== null && _selectedVariants$fin !== void 0 ? _selectedVariants$fin : 1;
  var quantity = isOption ? optionQuantity : mainProductQuantity;
  var max = isOption ? maxQuantity : mainProductAvailableInventory;
  var setQuantity = next => {
    if (isOption && variantId != null) {
      onChange(next);
    } else {
      setMainProductQuantity(next);
    }
  };
  var decrement = () => {
    var next = Math.max(quantity - 1, 1);
    if (next !== quantity) setQuantity(next);
  };
  var increment = () => {
    var next = Math.min(quantity + 1, max);
    if (next !== quantity) setQuantity(next);
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-justify-between tw-gap-2 tw-w-[90px] tw-m-0",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: " tw-w-[90px] tw-h-[39.5px] tw-grid tw-grid-cols-3 tw-items-center tw-rounded-[100px] tw-bg-[#FFFFFF] tw-overflow-hidden ",
    style: {
      border: "1px solid #E5E5E5"
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    disabled: quantity <= 1,
    onClick: e => {
      e.stopPropagation();
      decrement();
    },
    style: {
      border: "1px solid #FFFFFF"
    },
    className: " tw-h-full tw-flex tw-items-center tw-justify-center tw-text-[15px] tw-font-medium tw-text-[#000000] tw-select-none tw-p-0 "
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "16",
    viewBox: "0 0 14 16",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M2.50781 8H11.4911",
    stroke: "black",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-h-full tw-flex tw-items-center tw-justify-center"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-text-[15px] tw-font-medium tw-text-[#000000]"
  }, quantity)), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("button", {
    type: "button",
    disabled: quantity >= max,
    onClick: e => {
      e.stopPropagation();
      increment();
    },
    style: {
      border: "1px solid #FFFFFF"
    },
    className: " tw-h-full tw-flex tw-items-center tw-justify-center tw-text-[15px] tw-font-medium tw-text-[#000000] tw-select-none tw-p-0 "
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "16",
    viewBox: "0 0 14 16",
    fill: "none"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M2.50781 8H11.4911",
    stroke: "black",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("path", {
    d: "M7 3.50879V12.4921",
    stroke: "black",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (QuantitySelector);

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/required-product-group.js"
/*!*******************************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/required-product-group.js ***!
  \*******************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @headlessui/react */ "./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js");
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @headlessui/react */ "./node_modules/@headlessui/react/dist/components/radio-group/radio-group.js");
/* harmony import */ var _required_product_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./required-product-selector */ "./js/components/react/product-setup-drawer.js/required-product-selector.js");
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! lucide-react */ "./node_modules/lucide-react/dist/esm/icons/chevron-down.js");
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! lucide-react */ "./node_modules/lucide-react/dist/esm/icons/chevron-up.js");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./store */ "./js/components/react/product-setup-drawer.js/store.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils */ "./js/components/react/product-setup-drawer.js/utils.js");







var ProductGroup = _ref => {
  var _window$custom, _window$custom2;
  var {
    groupId,
    group,
    isRequired,
    syncQuantity
  } = _ref;
  var currentStep = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.currentStep);
  var updateVariant = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.updateVariant);
  var selectOption = ((_window$custom = window.custom) === null || _window$custom === void 0 ? void 0 : _window$custom.locales.selectOption) || "Select Option";
  var errorStateText = ((_window$custom2 = window.custom) === null || _window$custom2 === void 0 ? void 0 : _window$custom2.locales.errorStateText) || " ";
  var mainProductQuantity = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.mainProductQuantity);
  var addMissedGroupId = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.addMissedRequiredGroupIds);
  var isRequiredInfoFilled = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.isRequiredInfoFilled);
  var selectedVariants = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.selectedVariants);
  var missedRequiredGroupIds = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.missedRequiredGroupIds);
  var mainProductPrice = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.baseUnitPrice);
  var surcharge = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.surchargeForCaliforniaPercentage);
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);

  //console.log("group : ", group)
  var variantActiveProductGroups = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => state.selectedGroupIds);

  // ALWAYS SAFE ARRAYS
  var options = Array.isArray(group === null || group === void 0 ? void 0 : group.options) ? group.options : [];
  var answers = Array.isArray(group === null || group === void 0 ? void 0 : group.answers) ? group.answers : [];
  var allItems = [...options, ...answers];
  var groupSelectedVariant = (0,_store__WEBPACK_IMPORTED_MODULE_6__.productSetupStore)(state => {
    var _state$selectedVarian;
    return (_state$selectedVarian = state.selectedVariants.find(v => v.step === state.currentStep && v.groupId === groupId)) !== null && _state$selectedVarian !== void 0 ? _state$selectedVarian : null;
  });

  // undefined = nothing chosen yet
  // null = user chose None
  // number = user chose option/answer
  var selectedId = groupSelectedVariant == null ? "" : groupSelectedVariant.id === null ? "NONE" : String(groupSelectedVariant.id);
  var showErrorBorder = isRequiredInfoFilled && isRequired && !variantActiveProductGroups.includes(groupId);
  var [isOpen, setIsOpen] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (isRequired) {
      selectedVariants.find(v => v.groupId === groupId) ? null : addMissedGroupId(groupId);
    }
  }, []);

  // Close disclosure when currentStep changes
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setIsOpen(false);
  }, [currentStep]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (showErrorBorder && containerRef.current) {
      containerRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }
  }, [showErrorBorder, isRequiredInfoFilled, missedRequiredGroupIds, selectedVariants]);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__.Disclosure, {
    as: "div",
    open: isOpen,
    className: "disclosure-one"
  }, _ref2 => {
    var {
      open,
      close
    } = _ref2;
    var handleChange = selectedId => {
      var _selectedItem$compare;
      if (!selectedId) return;
      if (selectedId === "NONE") {
        updateVariant(currentStep, groupId, {
          id: null,
          title: group.noneOptionText,
          sku: null,
          isSurcharge: group.isSurcharge,
          discountedPrice: 0,
          compareAtPrice: 0,
          groupTitle: group.title,
          priceWithoutCurrency: 0,
          groupId,
          quantity: 1,
          availableInventory: null,
          isRequired,
          syncQuantity
        });
        close();
        return;
      }
      var selectedItem = allItems.find(item => item && String(item.id) === String(selectedId));
      if (!selectedItem) {
        console.error("Selected item not found", {
          selectedId,
          allItems
        });
        return;
      }
      var secondPart = "";
      if (group.isSurcharge) {
        var _split$;
        secondPart = ((_split$ = ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.title) || "").split("::")[1]) === null || _split$ === void 0 ? void 0 : _split$.trim().toLowerCase()) || "";
      }
      var finalPrice = 0;
      var isSurcharge = group.isSurcharge === true;
      // check if this is surcharge answer
      var isSurchargeAnswer = group.isSurcharge === true;
      //console.log("selectedItem: ", selectedItem);
      // calculate surcharge if needed
      if (isSurchargeAnswer) {
        var basePrice = (0,_utils__WEBPACK_IMPORTED_MODULE_7__.formatPrice)(mainProductPrice) || 0;
        var isValidSurcharge = surcharge != null && surcharge >= 1;
        if (isValidSurcharge && basePrice > 0 && secondPart === "true") {
          finalPrice = basePrice * surcharge / 100;
        } else {
          finalPrice = 0;
        }
      } else {
        finalPrice = selectedItem.discountedPrice ? (0,_utils__WEBPACK_IMPORTED_MODULE_7__.formatPrice)(selectedItem.discountedPrice) : 0;
      }
      updateVariant(currentStep, groupId, {
        id: selectedItem.id,
        title: selectedItem.title,
        productTitle: selectedItem.productTitle,
        sku: selectedItem.sku,
        isSurcharge: group.isSurcharge,
        priceWithoutCurrency: finalPrice,
        compareAtPrice: (0,_utils__WEBPACK_IMPORTED_MODULE_7__.formatPrice)((_selectedItem$compare = selectedItem.compareAtPrice) !== null && _selectedItem$compare !== void 0 ? _selectedItem$compare : 0),
        groupTitle: group.title,
        isRequired,
        groupId,
        quantity: 1,
        availableInventory: selectedItem.availableInventory,
        syncQuantity
      });
      close();
    };
    var previewItem = (groupSelectedVariant === null || groupSelectedVariant === void 0 ? void 0 : groupSelectedVariant.id) == null ? null : allItems.find(item => String(item.id) === String(groupSelectedVariant.id));
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      ref: containerRef,
      "data-error-group": showErrorBorder ? "true" : "false",
      className: "tw-flex tw-flex-col tw-rounded-lg",
      style: {
        borderRadius: "8px",
        border: "1px solid ".concat(showErrorBorder ? "#D32F2F" : "#E5E5E5"),
        background: "#FFF"
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__.Disclosure.Button, {
      as: "div",
      className: "tw-w-full tw-px-[12px] tw-pt-[12px] tw-flex tw-flex-col tw-gap-[8px] tw-cursor-pointer ".concat(open ? "tw-pb-[8px]" : "tw-pb-[12px]")
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-w-full tw-flex tw-justify-between tw-items-start"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("h3", {
      className: "tw-w-auto tw-text-[15px] tw-font-medium tw-text-black"
    }, group.title, isRequired && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "tw-text-[#D32F2F] tw-font-['DM_Sans'] tw-text-[15px] tw-font-medium tw-leading-[18px] tw-tracking-[-0.15px] tw-m-0 tw-p-0"
    }, "*")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
      className: "tw-w-[16px] tw-h-[16px] tw-p-0 tw-flex tw-items-center tw-justify-center"
    }, open ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(lucide_react__WEBPACK_IMPORTED_MODULE_5__["default"], {
      size: "16px"
    }) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(lucide_react__WEBPACK_IMPORTED_MODULE_4__["default"], {
      size: "16px"
    }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-w-full tw-flex tw-justify-between tw-items-center"
    }, groupSelectedVariant === null && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-text-[12px] tw-text-[#666] tw-leading-[16px] tw-font-medium "
    }, selectOption), groupSelectedVariant && !open && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-w-full tw-h-auto tw-gap-[8px] tw-flex tw-flex-col tw-justify-start tw-items-start "
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_required_product_selector__WEBPACK_IMPORTED_MODULE_3__["default"], {
      checked: true,
      product: previewItem,
      noneOptionTitle: group.noneOptionText,
      isSurcharge: group.isSurcharge
    })), showErrorBorder && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
      className: "tw-text-[#D32F2F] tw-text-[12px]"
    }, errorStateText))), open && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__.Disclosure.Panel, {
      static: true,
      className: "tw-px-[12px] tw-pb-[12px] tw-pt-0"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.RadioGroup, {
      value: selectedId || "",
      onChange: handleChange,
      className: "tw-flex tw-flex-col tw-gap-[12px]"
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.RadioGroup.Option, {
      key: "NONE",
      value: "NONE"
    }, _ref3 => {
      var _group$noneOptionText;
      var {
        checked
      } = _ref3;
      return group !== null && group !== void 0 && group.noneOptionText && (_group$noneOptionText = group.noneOptionText) !== null && _group$noneOptionText !== void 0 && _group$noneOptionText.trim() ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_required_product_selector__WEBPACK_IMPORTED_MODULE_3__["default"], {
        checked: checked,
        noneOptionTitle: group.noneOptionText
      }) : null;
    }), options.filter(option => {
      if (group.isSurcharge) return true;
      if (isRequired && option.available) {
        return option.availableInventory >= mainProductQuantity;
      }
      return option.available;
    }).map(option => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.RadioGroup.Option, {
      key: option.id,
      value: String(option.id)
    }, _ref4 => {
      var {
        checked
      } = _ref4;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_required_product_selector__WEBPACK_IMPORTED_MODULE_3__["default"], {
        checked: checked,
        product: option,
        isSurcharge: group.isSurcharge
      });
    })), answers.map(answer => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__.RadioGroup.Option, {
      key: answer.id,
      value: String(answer.id)
    }, _ref5 => {
      var {
        checked
      } = _ref5;
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_required_product_selector__WEBPACK_IMPORTED_MODULE_3__["default"], {
        checked: checked,
        product: answer,
        isSurcharge: group.isSurcharge
      });
    })))));
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductGroup);

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/required-product-selector.js"
/*!**********************************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/required-product-selector.js ***!
  \**********************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils */ "./js/components/react/product-setup-drawer.js/utils.js");
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./store */ "./js/components/react/product-setup-drawer.js/store.js");



function ProductRadioOption(_ref) {
  var _product$title;
  var {
    product,
    noneOptionTitle,
    isSurcharge,
    checked
  } = _ref;
  var mainProductPrice = (0,_store__WEBPACK_IMPORTED_MODULE_2__.productSetupStore)(state => state.baseUnitPrice);
  var surcharge = (0,_store__WEBPACK_IMPORTED_MODULE_2__.productSetupStore)(state => state.surchargeForCaliforniaPercentage);
  // only for surcharge options — shows per-unit surcharge price (not synced to quantity)
  var calculatedSurcharge = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    if (!product) return 0;
    var price = (0,_utils__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(mainProductPrice) || 0;
    var isLowOrMissingSurcharge = surcharge == null || surcharge < 1;
    if (!isLowOrMissingSurcharge && price > 0) {
      return price * surcharge / 100;
    }
    return 0;
  }, [mainProductPrice, surcharge, product]);
  var firstPart = "";
  var secondPart = "";
  if (isSurcharge) {
    var [rawFirst = "", rawSecond = ""] = ((product === null || product === void 0 ? void 0 : product.title) || "").split("::");
    firstPart = rawFirst;
    secondPart = rawSecond.trim().toLowerCase();
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: " tw-box-border tw-flex tw-flex-col tw-cursor-pointer tw-items-center tw-justify-between tw-rounded-[8px] tw-p-[12px] tw-w-full ".concat(checked ? "tw-bg-[#027DB329]" : "tw-bg-[#F4F6F8]"),
    style: {
      border: checked ? "1px solid #027DB3" : "1px solid #E5E5E5"
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-flex-col tw-justify-between tw-gap-[8px] tw-w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-flex tw-w-full tw-justify-between tw-leading-[18px] tw-items-center tw-gap-2"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: " tw-text-[15px] tw-break-words tw-leading-[16px] ".concat(checked ? "tw-text-[#000000]" : "tw-text-[#666666]")
  }, product ? isSurcharge ? (_product$title = product.title) === null || _product$title === void 0 ? void 0 : _product$title.split("::")[0] : product.title : noneOptionTitle), (product === null || product === void 0 ? void 0 : product.discountedPrice) != null && !isSurcharge ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-flex tw-justify-center tw-items-center tw-text-[15px] tw-w-auto tw-m-0 tw-p-0 tw-leading-none tw-font-semibold tw-whitespace-nowrap ".concat(checked ? "tw-text-[#000000]" : "tw-text-[#666666]")
  }, "+", " ", (0,_utils__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(product.discountedPrice, true, false, true))) : calculatedSurcharge > 0 && secondPart !== "false" && isSurcharge && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement((react__WEBPACK_IMPORTED_MODULE_0___default().Fragment), null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-flex tw-justify-center tw-items-center tw-text-[15px] tw-w-auto tw-m-0 tw-p-0 tw-leading-none tw-font-semibold tw-whitespace-nowrap ".concat(checked ? "tw-text-[#000000]" : "tw-text-[#666666]")
  }, "+", " ", (0,_utils__WEBPACK_IMPORTED_MODULE_1__.formatPrice)(calculatedSurcharge, true, false, true))))));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProductRadioOption);

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/store.js"
/*!**************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/store.js ***!
  \**************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   productSetupStore: () => (/* binding */ productSetupStore)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! zustand */ "./node_modules/zustand/esm/react.mjs");
/* harmony import */ var zustand_middleware__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! zustand/middleware */ "./node_modules/zustand/esm/middleware.mjs");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



// Helper to safely convert to number
var toNumber = value => {
  var num = Number(value);
  return Number.isFinite(num) ? num : 0;
};
var productSetupStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__.create)((0,zustand_middleware__WEBPACK_IMPORTED_MODULE_2__.subscribeWithSelector)((set, get) => ({
  currentStep: 0,
  totalSteps: 3,
  isLoading: false,
  isDisabled: false,
  itemCount: 0,
  mainProductQuantity: 1,
  mainProductAvailableInventory: Infinity,
  baseUnitPrice: 0,
  baseUnitCompareAtPrice: 0,
  totalPrice: 0,
  totalCompareAtPrice: 0,
  surchargeForCaliforniaPercentage: 0,
  setSurchargeForCaliforniaPercentage: value => set({
    surchargeForCaliforniaPercentage: value
  }),
  productGroupLenght: 0,
  isRequiredInfoFilled: false,
  errors: {
    errorOfRequiredField: "This field is required"
  },
  // Array of selected variants: { step, groupIndex, productId, id, priceWithoutCurrency, title, selectedQuantity }
  selectedVariants: [],
  selectedGroupIds: [],
  missedRequiredGroupIds: [],
  addGroupId: groupId => {
    set(state => {
      if (state.selectedGroupIds.includes(groupId)) return state;
      return {
        selectedGroupIds: [...state.selectedGroupIds, groupId]
      };
    });
    get().removeMissedRequiredGroupIds(groupId);
  },
  addMissedRequiredGroupIds: groupId => set(state => {
    if (state.missedRequiredGroupIds.includes(groupId)) return state;
    return {
      missedRequiredGroupIds: [...state.missedRequiredGroupIds, groupId]
    };
  }),
  removeMissedRequiredGroupIds: groupId => {
    set(state => {
      return {
        missedRequiredGroupIds: state.missedRequiredGroupIds.filter(existingId => existingId != groupId)
      };
    });
  },
  setMainProductQuantity: quantity => {
    set({
      mainProductQuantity: toNumber(quantity)
    });

    // 🔥 immediately recalc totals when quantity changes
    get().recalculateTotals();
  },
  setMainProductAvailableInventory: inventory => set({
    mainProductAvailableInventory: inventory == null || inventory === Infinity ? Infinity : toNumber(inventory)
  }),
  setPriceDetails: function setPriceDetails() {
    var price = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var compareAtPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    set({
      baseUnitPrice: toNumber(price),
      baseUnitCompareAtPrice: toNumber(compareAtPrice)
    });
    get().recalculateTotals();
  },
  // findAndStoreMissingGroupIds: (n) => {
  //   const { selectedVariants } = get();

  //   const selectedSet = new Set(
  //     selectedVariants.map(item => item.groupId)
  //   );

  //   const missing = [];

  //   for (let i = 0; i < n; i++) {
  //     if (!selectedSet.has(i)) {
  //       missing.push(i);
  //     }
  //   }

  //   set({ missingGroupIds: missing });
  // },

  setProductGroupLength: length => set({
    productGroupLength: length
  }),
  setIsRequiredInfoFilled: value => set({
    isRequiredInfoFilled: value
  }),
  // Check if current step has incomplete selections (product selected but no variant)
  checkDisabled: () => {
    var {
      selectedVariants,
      currentStep
    } = get();
    var isDisabled = selectedVariants.some(variant => (variant === null || variant === void 0 ? void 0 : variant.step) === currentStep && (variant === null || variant === void 0 ? void 0 : variant.productId) && !(variant !== null && variant !== void 0 && variant.id));
    set({
      isDisabled
    });
  },
  nextStep: () => {
    var {
      currentStep,
      totalSteps
    } = get();
    if (currentStep < totalSteps - 1) {
      set({
        currentStep: currentStep + 1,
        errors: {}
      });
      get().checkDisabled();
    }
  },
  prevStep: () => {
    var {
      currentStep
    } = get();
    if (currentStep > 0) {
      set({
        currentStep: currentStep - 1,
        errors: {}
      });
      get().checkDisabled();
    }
  },
  // Recalculate itemCount and totalPrice from selectedVariants
  recalculateTotals: () => {
    var {
      selectedVariants,
      baseUnitPrice,
      baseUnitCompareAtPrice,
      mainProductQuantity
    } = get();
    var mainQty = toNumber(mainProductQuantity);
    var itemCount = mainQty;
    var totalPrice = baseUnitPrice * mainQty;
    var totalCompareAtPrice = baseUnitCompareAtPrice * mainQty;
    get().checkDisabled();
    selectedVariants.forEach(variant => {
      if (variant && variant.id != null) {
        var price = toNumber(variant.priceWithoutCurrency) || 0;
        // const compareAtPrice =
        //   toNumber(variant.compareAtPrice) > toNumber(variant.priceWithoutCurrency)
        //     ? toNumber(variant.compareAtPrice)
        //     : toNumber(variant.priceWithoutCurrency); 
        var compareAtPrice = toNumber(variant.priceWithoutCurrency) || 0;
        var quantity = variant.syncQuantity ? toNumber(mainQty) : toNumber(variant.quantity);
        itemCount += quantity;
        totalPrice += price * quantity;
        totalCompareAtPrice += compareAtPrice * quantity;
      }
    });
    set({
      itemCount,
      totalPrice,
      totalCompareAtPrice
    });
  },
  updateVariant: (step, groupId, variantData) => {
    set(state => {
      var _ref, _variantData$quantity;
      if (!variantData) return state;
      var mainQty = get().mainProductQuantity || 1;
      var existingVariant = state.selectedVariants.find(v => v.groupId === groupId && (v.productId === variantData.productId || variantData.isRequired));
      var isOptionChanged = existingVariant && existingVariant.id !== variantData.id;
      var nextQuantity = variantData.syncQuantity ? toNumber(mainQty) : isOptionChanged ? 1 // ✅ reset on option change
      : toNumber((_ref = (_variantData$quantity = variantData.quantity) !== null && _variantData$quantity !== void 0 ? _variantData$quantity : existingVariant === null || existingVariant === void 0 ? void 0 : existingVariant.quantity) !== null && _ref !== void 0 ? _ref : 1);
      var newVariant = _objectSpread(_objectSpread(_objectSpread({}, existingVariant), variantData), {}, {
        step,
        groupId,
        quantity: nextQuantity // ✅ single source of truth
      });
      return {
        selectedVariants: existingVariant ? state.selectedVariants.map(v => v.groupId === groupId && (v.productId === variantData.productId || variantData.isRequired) ? newVariant : v) : [...state.selectedVariants, newVariant]
      };
    });
    get().recalculateTotals();
    get().addGroupId(groupId);
  },
  removeVariant: function removeVariant(step, groupId, productId) {
    var isRequired = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    set(state => {
      return {
        selectedVariants: state.selectedVariants.filter(v => !(v.step === step && v.groupId === groupId && (v.productId === productId || isRequired)))
      };
    });
    get().recalculateTotals();
  },
  removeVariantByGroup: (step, groupIndex) => {
    set(state => ({
      selectedVariants: state.selectedVariants.filter(v => !(v.step === step && v.groupIndex === groupIndex))
    }));
    get().recalculateTotals();
  },
  setLoading: isLoading => {
    set({
      isLoading
    });
  },
  // Reset entire store to initial state (called after add to cart)
  resetStore: () => {
    set({
      currentStep: 0,
      isLoading: false,
      isDisabled: false,
      itemCount: 0,
      totalPrice: 0,
      totalCompareAtPrice: 0,
      errors: {},
      selectedVariants: [],
      selectedGroupIds: [],
      missedRequiredGroupIds: [],
      isRequiredInfoFilled: false,
      mainProductQuantity: 1,
      mainProductAvailableInventory: Infinity
    });
  },
  // Reset selection state when a new product is opened (without clearing loading/price)
  resetForNewProduct: () => {
    set({
      currentStep: 0,
      selectedVariants: [],
      selectedGroupIds: [],
      missedRequiredGroupIds: [],
      isRequiredInfoFilled: false,
      isDisabled: false,
      mainProductQuantity: 1,
      mainProductAvailableInventory: Infinity
    });
  }
})));

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/utils.js"
/*!**************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/utils.js ***!
  \**************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatPrice: () => (/* binding */ formatPrice),
/* harmony export */   getPrice: () => (/* binding */ getPrice)
/* harmony export */ });
/* unused harmony exports getCurrentCurrencyCode, getCurrencySymbol, toNumberOrZero, indexPrefix */
/* harmony import */ var currency_symbol_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! currency-symbol-map */ "./node_modules/currency-symbol-map/currency-symbol-map.js");
/* harmony import */ var currency_symbol_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(currency_symbol_map__WEBPACK_IMPORTED_MODULE_0__);


/**
 * Get the current Shopify currency code
 * @returns {string|null} Currency code (e.g., 'USD', 'EUR')
 */
var getCurrentCurrencyCode = () => {
  var _window$Shopify$curre, _window;
  return (_window$Shopify$curre = (_window = window) === null || _window === void 0 || (_window = _window.Shopify) === null || _window === void 0 || (_window = _window.currency) === null || _window === void 0 ? void 0 : _window.active) !== null && _window$Shopify$curre !== void 0 ? _window$Shopify$curre : null;
};

/**
 * Get the currency symbol for the current Shopify currency
 * @returns {string} Currency symbol (e.g., '$', '€')
 */
var getCurrencySymbol = () => {
  var currencyCode = getCurrentCurrencyCode();
  return currency_symbol_map__WEBPACK_IMPORTED_MODULE_0___default()(currencyCode) || currencyCode || '$';
};

/**
 * Format a price with the current currency symbol
 * @param {number} price - The price to format
 * @param {boolean} showCode - Whether to show currency code after the price
 * @returns {string} Formatted price string
 */
var formatPrice = function formatPrice(price) {
  var showSymbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var showCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var showComma = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var symbol = getCurrencySymbol();
  var code = getCurrentCurrencyCode();
  var cleanPrice = String(price || "0").replace(/,/g, ""); // remove commas
  var formattedPrice = Number(cleanPrice).toFixed(2);

  // add comma formatting if enabled
  if (showComma) {
    formattedPrice = Number(formattedPrice).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  if (showCode && showSymbol && code) {
    return "".concat(symbol).concat(formattedPrice, " ").concat(code);
  }
  if (showSymbol && code) {
    return "".concat(symbol).concat(formattedPrice);
  }
  return "".concat(formattedPrice);
};

/**
 * Safely convert a value to a number, returning 0 if invalid
 * @param {any} value - Value to convert
 * @returns {number} Converted number or 0
 */
var toNumberOrZero = value => {
  var num = Number(value);
  return Number.isFinite(num) ? num : 0;
};
var getPrice = (price, variantId) => {
  var BASE_MAP = ["Q", "M", "Z", "A", "L", "X", "P", "R", "D", "K"];
  // index = digit 0–9

  function rotate(digit, shift) {
    return (digit + shift) % 10;
  }
  var shift = Number(variantId) % 10;
  var str = String(price);

  // checksum (rotated)
  var sum = str.split("").filter(c => c >= "0" && c <= "9").reduce((a, d) => a + Number(d), 0);
  var checksum = (sum + shift) % 10;
  var payload = "".concat(str).concat(checksum);

  // encrypt digits
  return payload.split("").map(char => {
    if (char < "0" || char > "9") return char;
    return BASE_MAP[rotate(Number(char), shift)];
  }).join("");
};
var indexPrefix = index => {
  var letters = 'abcdefghijklmnopqrstuvwxyz';
  var i = index;
  var prefix = '';
  do {
    prefix = letters[i % 26] + prefix;
    i = Math.floor(i / 26) - 1;
  } while (i >= 0);

  // ---- number part: 1, 2, 3 ...
  var number = index + 1;

  // ---- random part (your existing logic)
  var randomPart = (Date.now().toString(36) + Math.random().toString(36)).replace(/[^a-z0-9]/gi, '').slice(-6);
  return "".concat(prefix).concat(number, "-").concat(randomPart);
};

/***/ },

/***/ "./js/components/react/product-setup-drawer.js/variant-selector.js"
/*!*************************************************************************!*\
  !*** ./js/components/react/product-setup-drawer.js/variant-selector.js ***!
  \*************************************************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "./node_modules/react/index.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lucide-react */ "./node_modules/lucide-react/dist/esm/icons/chevron-down.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils */ "./js/components/react/product-setup-drawer.js/utils.js");



var VariantSelector = _ref => {
  var {
    variants = [],
    selectedVariantId,
    onChange
  } = _ref;
  var handleChange = e => {
    var selected = variants.find(v => v.id === Number(e.target.value));
    if (!selected) return;
    onChange === null || onChange === void 0 || onChange({
      id: selected.id,
      title: selected.title,
      price: selected.price,
      priceWithoutCurrency: (0,_utils__WEBPACK_IMPORTED_MODULE_2__.formatPrice)(selected.priceWithoutCurrency),
      availableInventory: selected.availableInventory
    });
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-w-full",
    onClick: e => e.stopPropagation()
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("div", {
    className: "tw-relative tw-w-full"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("select", {
    value: selectedVariantId !== null && selectedVariantId !== void 0 ? selectedVariantId : "",
    onChange: handleChange,
    style: {
      border: "1px solid #E5E7EB"
    },
    className: " tw-h-[40px] tw-w-full tw-px-4 tw-pr-10 tw-rounded-full tw-bg-[#FFFFFF] tw-text-[15px] tw-font-medium tw-text-[#666666] tw-appearance-none tw-outline-none focus:tw-ring-2 focus:tw-ring-[#D1D5DB] tw-cursor-pointer tw-transition "
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("option", {
    value: "",
    disabled: true
  }, "Select Variant"), variants.filter(variant => {
    return variant.available;
  }).map(variant => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("option", {
    key: variant.id,
    value: variant.id
  }, variant.title, " \u2014 ", (0,_utils__WEBPACK_IMPORTED_MODULE_2__.formatPrice)(variant.priceWithoutCurrency, true)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("span", {
    className: "tw-pointer-events-none tw-absolute tw-right-4 tw-top-1/2 tw-text-[#6B7280]",
    style: {
      transform: "translateY(-40%)"
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement(lucide_react__WEBPACK_IMPORTED_MODULE_1__["default"], {
    size: 18
  }))));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (VariantSelector);

/***/ },

/***/ "./js/components/storefront.js"
/*!*************************************!*\
  !*** ./js/components/storefront.js ***!
  \*************************************/
(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   buildGraphQLQuery: () => (/* binding */ buildGraphQLQuery),
/* harmony export */   buildMetafieldsFragment: () => (/* binding */ buildMetafieldsFragment),
/* harmony export */   buildProductFilter: () => (/* binding */ buildProductFilter),
/* harmony export */   createStorefrontApiClient: () => (/* binding */ createStorefrontApiClient)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! axios */ "./node_modules/axios/lib/axios.js");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function buildGraphQLQuery(queryName, variables, queryBody) {
  var variableDefs = Object.entries(variables).map(_ref => {
    var [name, type] = _ref;
    return "$".concat(name, ": ").concat(type);
  }).join(", ");
  return "query ".concat(queryName).concat(variableDefs ? "(".concat(variableDefs, ")") : "", " {\n    ").concat(queryBody, "\n  }");
}

//This is for fetching the non-indexed metafields value 
function buildMetafieldsFragment(metafieldIdentifiers) {
  if (!metafieldIdentifiers || metafieldIdentifiers.length === 0) {
    return "";
  }
  var identifiers = metafieldIdentifiers.map(id => {
    var namespace = id.namespace ? "namespace: \"".concat(id.namespace, "\"") : "";
    var key = "key: \"".concat(id.key, "\"");
    return "{ ".concat(namespace ? "".concat(namespace, ", ") : "").concat(key, " }");
  }).join(", ");
  return "metafields(identifiers: [".concat(identifiers, "]) {\n        namespace\n        key\n        value\n      }");
}
function buildProductFilter(activeFilters) {
  // Handle empty cases
  if (!activeFilters || !Array.isArray(activeFilters) || activeFilters.length === 0) {
    return [];
  }
  var filters = [];
  var curatedFilters = activeFilters.reduce((acc, f) => {
    if (f.filterType === 'price' && (f.key === 'gte' || f.key === 'lte')) {
      acc.price = acc.price || {};
      if (f.key === 'gte') acc.price.min = Number(f.value);
      if (f.key === 'lte') acc.price.max = Number(f.value);
    } else if (f.namespace != null && f.key != null) {
      // Never send price range as productMetafield — Storefront API has no such metafields; use only the price filter
      if (f.namespace === 'price' && (f.key === 'gte' || f.key === 'lte')) return acc;
      acc.metafields = acc.metafields || [];
      acc.metafields.push({
        namespace: f.namespace,
        key: f.key,
        value: String(f.value)
      });
    }
    return acc;
  }, {});

  // Process curated metafields
  if (curatedFilters.metafields) {
    curatedFilters.metafields.forEach(metafield => {
      filters.push({
        productMetafield: {
          namespace: metafield.namespace,
          key: metafield.key,
          value: metafield.value
        }
      });
    });
  }

  // Process curated price filter (Storefront API expects decimal; app stores cents)
  if (curatedFilters.price) {
    if (curatedFilters.price.min != null || curatedFilters.price.max != null) {
      var min = curatedFilters.price.min != null ? curatedFilters.price.min / 100 : undefined;
      var max = curatedFilters.price.max != null ? curatedFilters.price.max / 100 : undefined;
      filters.push({
        price: _objectSpread(_objectSpread({}, min != null && {
          min
        }), max != null && {
          max
        })
      });
    }
  }
  return filters;
}
function createStorefrontApiClient() {
  var STORE_URL = "https://2rjxej-im.myshopify.com";
  var STOREFRONT_ACCESS_TOKEN = "fd754092904670286ba90147747d8326";
  var apiClient = axios__WEBPACK_IMPORTED_MODULE_1__["default"].create({
    baseURL: "".concat(STORE_URL.replace(/\/$/, ""), "/api/2026-01/graphql.json"),
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
    },
    timeout: 30000
  });
  apiClient.interceptors.request.use(config => config, error => {
    console.error("Storefront API request error:", error);
    return Promise.reject(error);
  });
  apiClient.interceptors.response.use(response => response, error => {
    if (error.response) {
      console.error("Storefront API response error:", {
        status: error.response.status,
        statusText: error.response.statusText,
        data: error.response.data
      });
    } else if (error.request) {
      console.error("Storefront API request failed:", error.request);
    } else {
      console.error("Storefront API error:", error.message);
    }
    return Promise.reject(error);
  });
  return apiClient;
}

/***/ }

}]);